<template lang="pug" src="./settingsTable.pug"></template>

<script>
export default {
    props: {
        titles: {
            type: Array,
            required: true
        },
        translationPath: {
            type: Object,
            default: () => ({
                headers: null,
                data: null
            })
        },
        items: {
            type: Array,
            required: true
        },
        backUrl: {
            type: Object,
            default: () => {}
        },
        saveAction: {
            type: String,
            required: true
        },
        saveMutation: {
            type: String,
            required: true
        },
        existingTypes: {
            type: Array,
            required: true
        }
    },
    data: () => ({
        changed: false
    }),
    computed: {
        headers() {
            return [
                { text: 'name', value: 'name', sortable: false },
                { text: 'activation', sortable: false }
            ].map(it => Object.assign(it, {
                text: this.$vuetify.t(`${this.translationPath.headers}.${it.text}`)
            }))
        }
    },
    methods: {
        async saveChanges() {
            await this.$store.dispatch(`${this.saveAction}`, {
                enabled: this.items.filter(it => it.enabled).map('id')
            }).then(res => {
                if (res.data) {
                    this.changed = false

                    this.$store.dispatch('addMessage', {
                        type: 'success',
                        message: 'updated',
                        locale: true
                    }, { root: true })

                    this.$emit('existingTypesChange', {
                        existingTypes: [...res.data.map(it => Object.assign({}, it))]
                    })

                    this.$store.commit(`${this.saveMutation}`, res.data)
                }
            })
        },
        translateItem(item) {
            return this.$vuetify.t(`${this.translationPath.data}.${item}`)
        },
        onItemChange() {
            this.changed = !this.items.isEqual(this.existingTypes)
        }
    }
}
</script>

<style lang="scss" scoped>
    .table-wrap {
        max-width: 700px;
        margin: 0 auto;
    }

    .table {
        margin: 0 auto 10px;
        width: 100%;

        ::v-deep &__activation-field {
            display: flex;
            align-items: center;

            .v-input__control {
                margin: 0 auto;
            }

            .v-input__slot {
                margin: 0;
            }

            .v-messages {
                display: none;
            }
        }

        ::v-deep .v-table__overflow {
            max-height: calc(100vh - 170px) !important;
            overflow-y: scroll;
        }
    }

    .back-button {
        .v-icon {
            color: white;
        }
    }
</style>
